import { AllocationItemModel } from "@/model/allocation/allocationItemModel";
import { AllocationModel } from "@/model/allocation/allocationModel";

export function ConvertToAllocationList(_allocationList: any) {
  const allocationList: Array<AllocationModel> = [];
  if (_allocationList !== null) {
    _allocationList.forEach((element: any) => {
      allocationList.push({
        id: element.id,
        number: element.number,
        name: element.name,
        description: element.description,
        allocationDocumentFinanceType: element.allocationDocumentFinanceType,
        isArchived: element.isArchived,
        isDeleted: element.isDeleted,
      });
    });
  }
  return allocationList;
}

export function ConvertToAllocationItemList(_allocationItemList: any) {
  const allocationItemList: Array<AllocationItemModel> = [];
  if (_allocationItemList !== null) {
    _allocationItemList.forEach((element: any) => {
      allocationItemList.push({
        id: element.id,
        allocationId: element.allocationId,
        number: element.number,
        name: element.name,
        description: element.description,
        color: element.color,
        iconType: element.iconType,
        isArchived: element.isArchived,
        isDeleted: element.isDeleted,
      });
    });
  }
  return allocationItemList;
}
